export enum BoardingTaskStatus {
  processing = 'Processing',
  failed = 'Failed',
  done = 'Done',
  partialSuccess = 'Partially Successful',
}
